import { render, staticRenderFns } from "./ConfigurationData.vue?vue&type=template&id=00107790"
import script from "./ConfigurationData.vue?vue&type=script&lang=js"
export * from "./ConfigurationData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports